import styled from 'styled-components/macro';
import { GlobalColors, Rules } from 'src/App/Styles/Globals';
import { Platforms } from 'src/App/Types/app.types';

export const WelcomeContain = styled.div<{ platform: Platforms }>`
	position: relative;
	flex: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: 100%;
	width: 90%;
	margin: 1em auto;
	padding: 10px 20px;
	border-radius: ${Rules.radiusContainer};
	background: ${GlobalColors.gradient3};
	overflow: hidden;
	svg {
		position: absolute;
		width: 50px;
		opacity: 0.1;
		animation: SvgSubtle 10s forwards infinite;
	}
	svg:nth-of-type(1) {
		top: 30px;
		right: 0;
	}
	svg:nth-of-type(2) {
		width: 80px;
		top: 20px;
		left: -40px;
	}
	svg:nth-of-type(3) {
		width: 150px;
		bottom: 20px;
		right: -80px;
	}
	svg:nth-of-type(4) {
		bottom: -40px;
		left: 20px;
	}
	@keyframes SvgSubtle {
		0% {
			transform: translateY(0);
			opacity: 0.3;
		}
		50% {
			transform: translateY(-50px);
			opacity: 0.4;
		}
		100% {
			transform: translateY(0);
			opacity: 0.3;
		}
	}

	${({ platform }) =>
		platform === Platforms.MOBILE
			? `
	`
			: platform === Platforms.PANEL
			? `
	`
			: platform === Platforms.COMPONENT
			? `
	`
			: platform === Platforms.VIDEO
			? `
		background: transparent;
		`
			: platform === Platforms.WEB
			? `
	`
			: ``}
`;
export const WelcomeTitle = styled.h1`
	font-size: 40px;
	text-align: center;
	background: ${GlobalColors.newGradient};
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
`;
export const WelcomeDescription = styled.p`
	max-width: 400px;
`;
export const WelcomeBtn = styled.button<{ disabled: boolean }>`
	cursor: ${({ disabled }) => (disabled ? 'no-drop' : 'pointer')};
	background: ${GlobalColors.newGradient};
	opacity: ${({ disabled }) => (disabled ? '.4' : '1')};
	border: none;
	outline: none;
	padding: 1em;
	min-width: 200px;
	background: ${GlobalColors.newGradient};
	color: ${GlobalColors.white1};
	border-radius: 25px;
	font-size: 20px;
	font-weight: 800;
`;
export const OfflineIcon = styled.div`
	svg {
		position: static;
		width: 100%;
		animation: MiddleSvg 20s forwards infinite;
	}
	@keyframes MiddleSvg {
		0% {
			transform: translateY(0);
			opacity: 0.9;
		}
		50% {
			transform: translateY(-10px);
			opacity: 1;
		}
		100% {
			transform: translateY(0);
			opacity: 0.9;
		}
	}
`;
